import React, { useRef, useEffect, useState, useContext, useMemo, useLayoutEffect } from 'react';
import styles from './GanttChartAll.module.css';
import Procesory from './procesory_btn/Procesory';
import { AppContext } from 'context/AppContext';
import { druk_alert } from 'actions/druk_alert';
import { useGant } from './useGant';
import { Magnet, RefreshCcw, Scaling, X, XCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getNameOfElementTyp } from 'actions/getNameOfElementTyp';
import GanttContextMenu from './GanttContextMenu';
import ModalGrupyTechnologii from './ModalGrupyTech/ModalGrupyTechnologii';
import { TechnologyContext } from 'context/TechnologyContext';
import { updateZmienCzasTrwaniaGrupyGant } from 'actions/updateZmienCzasTrwaniaGrupyGant';
import { updateZmienCzasTrwaniaGrupyGantPrzerwa } from 'actions/updateZmienCzasTrwaniaGrupyGantPrzerwa';
import { updateZmienCzasTrwaniaGrupyOprawaGant } from 'actions/updateZmienCzasTrwaniaGrupyOprawaGant';
import { updateZmienCzasTrwaniaGrupyOprawaGantPrzerwa } from 'actions/updateZmienCzasTrwaniaGrupyOprawaGantPrzerwa';
import { dateISOtoPL } from 'actions/dateISOtoPL';
import { date_time } from 'actions/date_time';
import { date_bez_time } from 'actions/date_bez_time';


const GanttChartAll = ({ stages }) => {
  const chartRef = useRef(null);
  const scrollWrapperRef = useRef(null);
  const { setGrupaWykonan } = useContext(TechnologyContext);

  const [minDate, setMinDate] = useState(null);
  const [etykieta, setEtykieta] = useState("");
  const [maxDate, setMaxDate] = useState(null);
  const [totalChartWidth, setTotalChartWidth] = useState(0);
  const [scaleFactor, setScaleFactor] = useState(0.5);

  
  const contextApp = useContext(AppContext);
  const procesory = contextApp.procesory;
  
  const [nowTime, setNowTime] = useState(new Date()); 
  const [colorFrom, setColorFrom] = useState(4);

  const [selectedGrup, setSelectedGrup] = useState(null);
  const [selectedZamowienieId, setSelectedZamowienieId] = useState(null);
  const [selectedShipmentDate, setSelectedShipmentDate] = useState(null);
  const [rowYPositions, setRowYPositions] = useState({});
  const [refreshGant, refreshGantAll, refreshGantZakonczone] = useGant();
  const [contextMenu, setContextMenu] = useState(null);

  const [showHourLines, setShowHourLines] = useState(true);
  const [modalGrupyOpen, setModalGrupyOpen] = useState(false);
  const [resizable, setResizable] = useState(false);

  // Stany dla obsługi przeciągania (resize) i snapowania
  const [isResizing, setIsResizing] = useState(false);
  const [resizingStage, setResizingStage] = useState(null);
  const [resizeStartX, setResizeStartX] = useState(0);
  const [currentWidthPx, setCurrentWidthPx] = useState(0);
  const [resizingEndDate, setResizingEndDate] = useState(null);
  const [resizingLeftPx, setResizingLeftPx] = useState(0);
  const [isSnapping, setIsSnapping] = useState(false);

  const navigate = useNavigate();

  // Grupowanie etapów według procesora
  const groupedStages = useMemo(() => {
    return stages?.reduce((acc, stage) => {
      const { procesor_id } = stage;

      if (procesor_id === 51 || procesor_id === 52) {
        return acc;
      }

      if (!acc[procesor_id]) {
        acc[procesor_id] = [];
      }
      acc[procesor_id].push(stage);
      return acc;
    }, {});
  }, [stages]);

  const processorIds = useMemo(() => Object.keys(groupedStages || {}), [groupedStages]);
  const allStagesList = useMemo(() => Object.values(groupedStages || {}).flat(), [groupedStages]);

  useEffect(() => {
    if (allStagesList && allStagesList.length > 0) {
      const allDates = allStagesList.flatMap(stage => [new Date(stage.start), new Date(stage.end)]);

      if (allDates.length === 0) return;

      const calculatedMinDate = new Date(Math.min(...allDates));
      const calculatedMaxDate = new Date(Math.max(...allDates));

      calculatedMinDate.setHours(calculatedMinDate.getHours() - 1, 0, 0, 0);
      calculatedMaxDate.setHours(calculatedMaxDate.getHours() + 2, 0, 0, 0);

      setMinDate(calculatedMinDate);
      setMaxDate(calculatedMaxDate);

      const totalTimeSpanMinutes = (calculatedMaxDate.getTime() - calculatedMinDate.getTime()) / (1000 * 60);
      setTotalChartWidth(totalTimeSpanMinutes * scaleFactor);
    }
  }, [allStagesList, scaleFactor]);

  useLayoutEffect(() => {
    if (!chartRef.current) return;
    
    const rows = chartRef.current.querySelectorAll(`.${styles.processorRow}`);
    const positions = {};

    processorIds.forEach((processorId, index) => {
      if (rows[index]) {
        positions[processorId] = rows[index].offsetTop + (rows[index].offsetHeight / 2);
      }
    });

    setRowYPositions(positions);
  }, [processorIds, totalChartWidth, scaleFactor, stages]);

  // useEffect(() => {
  //   if (!minDate || !maxDate || totalChartWidth === 0) return;

  //   const timer = setTimeout(() => {
  //     handleScrollToNow();
  //   }, 50);

  //   return () => clearTimeout(timer);
  // }, [scaleFactor, totalChartWidth]);


useEffect(() => {
    const timer = setTimeout(() => {
      handleScrollToNow();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const calculateBarProperties = (start, end) => {
    if (!minDate || !maxDate || !totalChartWidth) {
      return { width: '0px', marginLeft: '0px', leftPx: 0, widthPx: 0 };
    }

    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const stageDurationMs = new Date(end).getTime() - new Date(start).getTime();
    const startOffsetMs = new Date(start).getTime() - minDate.getTime();

    const widthPx = Math.max(0, (stageDurationMs / totalTimeSpanMs) * totalChartWidth);
    const marginLeftPx = Math.max(0, (startOffsetMs / totalTimeSpanMs) * totalChartWidth);

    return {
      width: `${widthPx}px`,
      marginLeft: `${marginLeftPx}px`,
      leftPx: marginLeftPx,
      widthPx: widthPx
    };
  };

  // Funkcja pomocnicza do snapowania do pełnej godziny
  const snapDateToNearestHour = (dateObj) => {
    const minutes = dateObj.getMinutes();
    const hours = dateObj.getHours();
    
    if (minutes >= 30) {
      dateObj.setHours(hours + 1, 0, 0, 0);
    } else {
      dateObj.setHours(hours, 0, 0, 0);
    }
    return dateObj;
  };

  // Globalna obsługa zdarzeń przeciągania krawędzi (resize)
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing || !resizingStage) return;
      
      const deltaX = e.clientX - resizeStartX;
      const { widthPx: initialWidthPx, leftPx: initialLeftPx } = calculateBarProperties(resizingStage.start, resizingStage.end);
      
      const newWidth = Math.max(20, initialWidthPx + deltaX);
      setCurrentWidthPx(newWidth);
      setResizingLeftPx(initialLeftPx + newWidth);

      const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
      const durationMs = (newWidth / totalChartWidth) * totalTimeSpanMs;
      const startTimeMs = new Date(resizingStage.start).getTime();
      let currentEndTimeMs = startTimeMs + durationMs;
      
      let currentDateObj = new Date(currentEndTimeMs);
      if (isSnapping) {
        currentDateObj = snapDateToNearestHour(currentDateObj);
      }

      setResizingEndDate(currentDateObj);
    };

    const formatDateToCustomString = (dateObj) => {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};
    const handleMouseUp = (e) => {
      if (!isResizing || !resizingStage) return;

      const deltaX = e.clientX - resizeStartX;
      const { widthPx: initialWidthPx } = calculateBarProperties(resizingStage.start, resizingStage.end);
      const finalWidthPx = Math.max(20, initialWidthPx + deltaX);

      const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
      const durationMs = (finalWidthPx / totalChartWidth) * totalTimeSpanMs;
      
      const startTimeMs = new Date(resizingStage.start).getTime();
      let newEndTimeMs = startTimeMs + durationMs;
      
      let newEndDateObj = new Date(newEndTimeMs);
      if (isSnapping) {
        newEndDateObj = snapDateToNearestHour(newEndDateObj);
      }

      // const newEndDate = newEndDateObj.toISOString();
      const newEndDate = formatDateToCustomString(newEndDateObj);


      if (typeof updateZmienCzasTrwaniaGrupyGant === "function") {
        // updateZmienCzasTrwaniaGrupyGant(resizingStage.global_id, newEndDate,refreshGantAll);

        if (resizingStage.proces_nazwa_id == 6) {
          //oprawa
                  if (resizingStage.typ_grupy === 1) {
          updateZmienCzasTrwaniaGrupyOprawaGantPrzerwa(
            resizingStage.global_id,
            newEndDate,
            refreshGantAll,
          );
        } else if (resizingStage.typ_grupy === 2) {
          updateZmienCzasTrwaniaGrupyOprawaGant(
            resizingStage.global_id,
            newEndDate,
            refreshGantAll,
          );
        }


        }else{
          //reszta procesow
                  if (resizingStage.typ_grupy === 1) {
          updateZmienCzasTrwaniaGrupyGantPrzerwa(
            resizingStage.global_id,
            newEndDate,
            refreshGantAll,
          );
        } else if (resizingStage.typ_grupy === 2) {
          updateZmienCzasTrwaniaGrupyGant(
            resizingStage.global_id,
            newEndDate,
            refreshGantAll,
          );
        }
        }



        
      }




      setIsResizing(false);
      setResizingStage(null);
      setResizingEndDate(null);
    };

    if (isResizing) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing, resizeStartX, resizingStage, minDate, maxDate, totalChartWidth, isSnapping]);

  const getColor = (stage, technologiaId, zamowienieId) => {
    let parametr;

    if (colorFrom === 1) { 
      parametr = stage.klient_id;
      let hash = 0;
      const str = String(parametr);
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = Math.abs(hash) % 360; 
      return `hsl(${hue}, 75%, 60%)`;
    }

    if (colorFrom === 2) { 
      const hashString = `${technologiaId}-${zamowienieId}`;
      let hash = 0;
      for (let i = 0; i < hashString.length; i++) {
        hash = hashString.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = (technologiaId * 137.508) % 360;
      const saturation = 70 + (hash % 30);
      const lightness = 50 + (hash % 10);
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }

    if (colorFrom === 3) { 
      parametr = stage.data_spedycji;
      let hash = 0;
      const str = String(parametr);
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = Math.abs(hash) % 360; 
      return `hsl(${hue}, 75%, 60%)`;
    }

    if (colorFrom === 4) { 
      if (stage.typ_grupy == 1) return ` #cfcfcf52 `;
      if (stage.status == 1) return ` #aaaaaa7c `;
      if (stage.status == 2) return `#a5cc52`;
      if (stage.status == 3) return `#c2b245`;
      if (stage.status == 4) return `#838383`;
    }
  };


    const getOutlineSelected = (stage) => {
  

      // if (stage.typ_grupy == 1  ) return `2px solid #16e020`
            if (stage.typ_grupy == 1  ) return `1px solid #cfcfcf`;

      if (stage.typ_grupy == 2 ) return `2px solid #4d9aff`;

    
  };

      const getOutline = (stage) => {
  
      
  
      if (stage.typ_grupy == 1  ) return `1px solid #cfcfcf`;
     
      if (stage.typ_grupy == 2  ) return `none`;

    
  };

  const renderWeekendBackgrounds = () => {
    if (!minDate || !maxDate || totalChartWidth === 0) return null;

    const weekendBlocks = [];
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();

    let currentDate = new Date(minDate);
    currentDate.setHours(0, 0, 0, 0);

    while (currentDate <= maxDate) {
      const dayOfWeek = currentDate.getDay();

      if (dayOfWeek === 6 || dayOfWeek === 0) {
        const dayStart = new Date(currentDate);
        const dayEnd = new Date(currentDate);
        dayEnd.setHours(23, 59, 59, 999);

        const actualStart = dayStart < minDate ? minDate : dayStart;
        const actualEnd = dayEnd > maxDate ? maxDate : dayEnd;

        const startOffsetMs = actualStart.getTime() - minDate.getTime();
        const durationMs = actualEnd.getTime() - actualStart.getTime();

        const leftPx = (startOffsetMs / totalTimeSpanMs) * totalChartWidth;
        const widthPx = (durationMs / totalTimeSpanMs) * totalChartWidth;

        weekendBlocks.push(
          <div
            key={`weekend-${currentDate.getTime()}`}
            className={styles.weekendOverlay}
            style={{ left: `${leftPx}px`, width: `${widthPx}px` }}
          />
        );
      }

      currentDate.setDate(currentDate.getDate() + 1);
    }

    return weekendBlocks;
  };

const renderHourLines = () => {
    if (!showHourLines || !minDate || !maxDate || totalChartWidth === 0) return null;

    const lines = [];
    const interval = 24 * 60 * 60 * 1000;
    const startDate = new Date(minDate);
    startDate.setHours(0, 0, 0, 0);

    let currentDate = new Date(startDate);
    let dayIndex = 0;

    while (currentDate <= maxDate) {
      let hoursToAdd = scaleFactor < 0.3 ? [6, 18] : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

      hoursToAdd.forEach((hour, hourIndex) => {
        const hourDate = new Date(currentDate);
        hourDate.setHours(hour, 0, 0, 0);

        if (hourDate >= minDate && hourDate <= maxDate) {
          const hourOffsetMs = hourDate.getTime() - minDate.getTime();
          const hourLeftPosition = (hourOffsetMs / (maxDate.getTime() - minDate.getTime())) * totalChartWidth;

          lines.push(
            <div 
              key={`grid-line-${dayIndex}-${hourIndex}-${hourDate.getTime()}`} // Unikalny klucz dla linii siatki
              className={styles.hourLineGrid}
              style={{ left: `${hourLeftPosition}px` }}
            />
          );
        }
      });

      currentDate.setTime(currentDate.getTime() + interval);
      dayIndex++;
    }
    return lines;
  };
const renderTimelineMarkers = (prefix = 'marker') => {
    if (!minDate || !maxDate || totalChartWidth === 0) return null;

    const markers = [];
    const daysOfWeek = ['N', 'Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'So'];
    const interval = 24 * 60 * 60 * 1000;
    
    const startDate = new Date(minDate);
    startDate.setHours(0, 0, 0, 0);

    let currentDate = new Date(startDate);
    let dayIndex = 0;

    while (currentDate <= maxDate) {
      const offsetMs = currentDate.getTime() - minDate.getTime();
      const leftPosition = (offsetMs / (maxDate.getTime() - minDate.getTime())) * totalChartWidth;

      markers.push(
        <div 
          key={`${prefix}-day-${dayIndex}-${currentDate.getTime()}`} 
          className={styles.timelineMarker} 
          style={{ left: `${leftPosition}px`, transform: 'translateX(-50%)' }}
        >
          {daysOfWeek[currentDate.getDay()]} {String(currentDate.getDate()).padStart(2, '0')}/{String(currentDate.getMonth() + 1).padStart(2, '0')}
        </div>
      );

      let hoursToAdd = scaleFactor < 0.3 ? [6, 18] : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

      hoursToAdd.forEach((hour, hourIndex) => {
        const hourDate = new Date(currentDate);
        hourDate.setHours(hour, 0, 0, 0);

        if (hourDate >= minDate && hourDate <= maxDate) {
          const hourOffsetMs = hourDate.getTime() - minDate.getTime();
          const hourLeftPosition = (hourOffsetMs / (maxDate.getTime() - minDate.getTime())) * totalChartWidth;

          markers.push(
            <div 
              key={`${prefix}-hour-${dayIndex}-${hourIndex}-${hourDate.getTime()}`} 
              className={styles.timelineSubMarker} 
              style={{ left: `${hourLeftPosition}px`, transform: 'translateX(-50%)' }}
            >
              {hour}:00
            </div>
          );
        }
      });

      currentDate.setTime(currentDate.getTime() + interval);
      dayIndex++;
    }
    return markers;
  };
  const calculateNowPosition = () => {
    if (!minDate || !maxDate || totalChartWidth === 0) return 0;
    const now = nowTime.getTime();
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const nowOffsetMs = now - minDate.getTime();
    const leftPosition = (nowOffsetMs / totalTimeSpanMs) * totalChartWidth;
    return Math.max(0, Math.min(leftPosition, totalChartWidth));
  };

  const calculateShipmentPosition = () => {
    if (!minDate || !maxDate || totalChartWidth === 0 || !selectedShipmentDate) return 0;
    const shipmentDateObj = new Date(selectedShipmentDate);
    shipmentDateObj.setHours(6, 0, 0, 0);

    const shipmentTime = shipmentDateObj.getTime();
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const shipmentOffsetMs = shipmentTime - minDate.getTime();
    const leftPosition = (shipmentOffsetMs / totalTimeSpanMs) * totalChartWidth;

    return Math.max(0, Math.min(leftPosition, totalChartWidth));
  };



  const handleScrollToNow = () => {
    if (!scrollWrapperRef.current || !minDate || !maxDate || totalChartWidth === 0) return;
    const now = new Date();
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const nowOffsetMs = now.getTime() - minDate.getTime();
    const scrollPosition = (nowOffsetMs / totalTimeSpanMs) * totalChartWidth;
    scrollWrapperRef.current.scrollLeft = scrollPosition - (scrollWrapperRef.current.clientWidth / 2);
  };
    const handleScaleChange = (event) => {
    setScaleFactor(event);

  };



  const connectionLines = useMemo(() => {
    if (!selectedZamowienieId || !minDate || !maxDate || !totalChartWidth) return [];

    const matchedStages = [];

    processorIds.forEach((processorId) => {
      const rowStages = groupedStages[processorId] || [];
      const y = rowYPositions[processorId] || 0;

      rowStages.forEach(stage => {
        if (stage.zamowienie_id === selectedZamowienieId) {
          const { leftPx, widthPx } = calculateBarProperties(stage.start, stage.end);

          matchedStages.push({
            startMs: new Date(stage.start).getTime(),
            outPoint: { x: leftPx + widthPx, y },
            inPoint: { x: leftPx, y }
          });
        }
      });
    });

    matchedStages.sort((a, b) => a.startMs - b.startMs);

    const lines = [];
    for (let i = 0; i < matchedStages.length - 1; i++) {
      lines.push({
        from: matchedStages[i].outPoint,
        to: matchedStages[i + 1].inPoint
      });
    }

    return lines;
  }, [selectedZamowienieId, groupedStages, processorIds, rowYPositions, minDate, maxDate, totalChartWidth]);

  const handleCenterOnStage = (stage, targetScale = 0.5) => {
  if (!minDate || !maxDate || !totalChartWidth || !scrollWrapperRef.current) return;

  // 1. Ustawienie nowego zoomu
  setScaleFactor(targetScale);

  // 2. Obliczenie pozycji klocka po zmianie zoomu 
  // (używamy szerokości przeliczonej dla nowej skali)
  const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
  const startOffsetMs = new Date(stage.start).getTime() - minDate.getTime();
  
  // Uwaga: totalChartWidth przeliczy się asynchronicznie, 
  // dlatego najlepiej wyliczyć nową szerokość bazując na targetScale
  const estimatedTotalWidth = ((maxDate.getTime() - minDate.getTime()) / (1000 * 60)) * targetScale;
  const stageLeftPx = (startOffsetMs / totalTimeSpanMs) * estimatedTotalWidth;
  const stageDurationMs = new Date(stage.end).getTime() - new Date(stage.start).getTime();
  const stageWidthPx = (stageDurationMs / totalTimeSpanMs) * estimatedTotalWidth;

  const stageCenterPx = stageLeftPx + (stageWidthPx / 2);

  // 3. Wyśrodkowanie w kontenerze przewijania z opóźnieniem na przerysowanie DOM
  setTimeout(() => {
    if (scrollWrapperRef.current) {
      const containerWidth = scrollWrapperRef.current.clientWidth;
      scrollWrapperRef.current.scrollLeft = stageCenterPx - (containerWidth / 2);
    }
  }, 50);
};


const handleCenterOnNow = (targetScale = 0.5) => {
  if (!minDate || !maxDate || !totalChartWidth || !scrollWrapperRef.current) return;

  // 1. Ustawienie nowego zoomu
  setScaleFactor(targetScale);

  // 2. Obliczenie pozycji "teraz" (now) po zmianie zoomu
  const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
  const now = new Date();
  const nowOffsetMs = now.getTime() - minDate.getTime();
  
  // Szacowana całkowita szerokość wykresu dla nowej skali
  const estimatedTotalWidth = ((maxDate.getTime() - minDate.getTime()) / (1000 * 60)) * targetScale;
  const nowPositionPx = (nowOffsetMs / totalTimeSpanMs) * estimatedTotalWidth;

  // 3. Wyśrodkowanie w kontenerze przewijania z opóźnieniem na przerysowanie DOM
  setTimeout(() => {
    if (scrollWrapperRef.current) {
      const containerWidth = scrollWrapperRef.current.clientWidth;
      scrollWrapperRef.current.scrollLeft = nowPositionPx - (containerWidth / 2);
    }
  }, 50);
};
  return (
    <div className={styles.chartContainer}>
      <div className={styles.header}>
        <div className={styles.btnFormContainer}>
          {/* <button title='Odśwież widok' className={styles.refreshBtn} onClick={() => { refreshGantAll() }}>
            <RefreshCcw style={{ paddingBottom: '2px', color: '#25be11' }} size={25} />
          </button> */}

                              <button 
            className={styles.scrollToNowBtn}
            onClick={() => refreshGantAll()}
            style={{ backgroundColor: '#8abe11' }}
            title="Odśwież"
          >
            <RefreshCcw size={20} style={{marginRight:"0px"}}/>
            {/* {isSnapping ? 'Wł.' : 'Wył.'} */}
          </button>
          {/* <button 
  className={styles.scrollToNowBtn}
  onClick={() => {
    if (selectedGrup) {
      handleCenterOnStage(selectedGrup, 1.0); // Ustawia zoom 1.0 i centruje
    }
  }}
  style={{ backgroundColor: '#4d9aff' }}
  title="Wyśrodkuj na zaznaczonym klocku (Zoom 1.0)"
>
  Wyśrodkuj klocek
</button> */}
        </div>

        <div className={styles.controls}>
          {/* Przycisk przełączania snapowania */}
          <button 
            className={styles.scrollToNowBtn}
            onClick={() => setResizable(prev => !prev)}
            style={{ backgroundColor: resizable ? '#8abe11' : '#63636396' }}
            title="Rozciąganie klocka"
          >
            <Scaling size={20}  style={{marginRight:"0px"}}/>
             {/* {resizable ? 'Wł.' : 'Wył.'} */}
          </button>


                    <button 
            className={styles.scrollToNowBtn}
            onClick={() => setIsSnapping(prev => !prev)}
            style={{ backgroundColor: isSnapping ? '#8abe11' : '#63636396' }}
            title="Przyciąganie klocka do pełnej godziny"
          >
            <Magnet size={20} style={{marginRight:"0px"}}/>
            {/* {isSnapping ? 'Wł.' : 'Wył.'} */}
          </button>

          <button className={styles.scrollToNowBtn} onClick={handleScrollToNow}>
            Teraz
          </button>
          {/* <span>Zoom:</span>
          <input
            type="range"
            min="0.05"
            max="2.0"
            step="0.05"
            value={scaleFactor}
            onChange={handleScaleChange}
          />
          <span style={{ marginLeft: '10px' }}>{scaleFactor.toFixed(2)}x</span> */}
          <span>Zoom:</span>
<div style={{ display: 'inline-flex', gap: '5px', marginLeft: '10px' }}>
  {[0.05,0.25, 0.5, 1.0, 2.0].map((val) => (
    <button
      key={val}
      // onClick={() => handleScaleChange(val)}
      onClick={() => handleCenterOnNow(val)}
      
      style={{
        padding: '4px 8px',
        backgroundColor: scaleFactor === val ? '#8abe11' : '#f0f0f0',
        color: scaleFactor === val ? '#fff' : '#000',
        border: '1px solid #ccc',
        cursor: 'pointer',
        borderRadius: '4px'
      }}
    >
      {val}x
    </button>
  ))}
</div>
       
          <button 
            title="Zamknij"
            style={{ background: 'transparent', border: 'none', marginRight: '10px' }}
            onClick={() => { navigate("/Panel"); }}
          >
            <X style={{ marginLeft: '20px', color: '#ffffffd4', height: '30px', width: '30px', padding: '5px', backgroundColor: '#ff0000', borderRadius: '5px' }} size={10} />
          </button>
        </div>
      </div>

      <div className={styles.ganttWrapper}>
        <div className={styles.stageNamesList}>
          <div className={styles.timeline} style={{ visibility: 'hidden', pointerEvents: 'none' }}>
            <div className={styles.timelineMarkersContainer} />
            <div className={styles.timelineLine} />
          </div>
          
          {groupedStages && Object.keys(groupedStages).map(processorId => (
            <div key={`names-group-${processorId}`} className={styles.processorRow}>
              <div className={styles.processorNameFixed}>
                {procesory.find(x => x.id == processorId)?.nazwa}
              </div>
            </div>
          ))}
        </div>

        <div className={styles.scrollWrapper} ref={scrollWrapperRef}>
          <div
            ref={chartRef}
            className={styles.ganttChart}
            style={{ width: `${totalChartWidth}px`, position: 'relative' }}
          >
            {renderWeekendBackgrounds()}
            {renderHourLines()}

            {/* Pionowa linia pomocnicza podczas resize'owania */}
            {isResizing && (
              <div 
                className={styles.resizeGuideLine} 
                style={{ left: `${resizingLeftPx}px` }}
              />
            )}

            <svg
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 10
              }}
            >
              <defs>
                <marker
                  id="arrowhead"
                  markerWidth="6"
                  markerHeight="6"
                  refX="5"
                  refY="3"
                  orient="auto"
                >
                  <polygon points="0 0, 6 3, 0 6" fill="#ff4d4f" />
                </marker>
              </defs>

              {connectionLines.map((line, index) => {
                const { from, to } = line;
                const deltaX = Math.max(20, Math.abs(to.x - from.x) / 2);
                const pathData = `M ${from.x} ${from.y} C ${from.x + deltaX} ${from.y}, ${to.x - deltaX} ${to.y}, ${to.x} ${to.y}`;

                return (
                  <g key={`connection-${index}`}>
                    <path
                      d={pathData}
                      fill="none"
                      stroke="#4d9aff"
                      strokeWidth="2.5"
                      strokeDasharray="5 3"
                      markerEnd="url(#arrowhead)"
                    />
                    <circle cx={from.x} cy={from.y} r="3.5" fill="#ff4d4f" />
                  </g>
                );
              })}
            </svg>

            <div className={styles.timeline}>
              <div className={styles.timelineMarkersContainer}>
                {renderTimelineMarkers('top')}
              </div>
              <div className={styles.timelineLine}></div>
            </div>

            <div className={styles.nowLine} style={{ left: `${calculateNowPosition()}px` }}>
              <span className={styles.nowLabel}>TERAZ</span>
            </div>  

            {selectedShipmentDate && (
              <div 
                className={styles.nowLine} 
                style={{ left: `${calculateShipmentPosition()}px`, backgroundColor: '#efd808' }}
              >
                <span className={styles.nowLabelSpedycja} style={{ backgroundColor: '#efd808' }}>SPEDYCJA</span>
              </div>
            )}

            {groupedStages && Object.keys(groupedStages).map(processorId => (
              <div key={`bars-group-${processorId}`} className={styles.processorRow}>
                <div className={styles.processorBarsGroup}>
                  {groupedStages[processorId].map(stage => {
                    const { width, marginLeft, widthPx: baseWidthPx } = calculateBarProperties(stage.start, stage.end);
                    const barColor = getColor(stage, stage.technologia_id, stage.zamowienie_id,colorFrom);
                    const isSelected = selectedZamowienieId === stage.zamowienie_id;
                    const barOutlineSelected = getOutlineSelected(stage);
                    const barOutline= getOutline(stage);
                    const isCurrentlyResizing = isResizing && resizingStage?.global_id === stage.global_id;
                    
                    const finalWidth = isCurrentlyResizing ? `${currentWidthPx}px` : width;

                    return (
                      <div
                        key={`bar-${stage.global_id}`}
                        className={styles.stageBar}
                        onContextMenu={(e) => {
                          setGrupaWykonan([]);
                          const isSame = selectedZamowienieId === stage.zamowienie_id;
                          setSelectedGrup(stage);
                          setSelectedZamowienieId(isSame ? null : stage.zamowienie_id);
                          setSelectedShipmentDate(isSame ? null : stage.data_spedycji);
                          e.preventDefault();
                          setContextMenu({ x: e.clientX, y: e.clientY, stage: stage });
                        }}
                        style={{
                          width: finalWidth,
                          marginLeft,
                          backgroundColor: barColor,
                          // outline: isSelected ? '2px solid #4d9aff' : 'none',
                          border: isSelected ? barOutlineSelected:barOutline ,
                          outlineOffset: '2px',
                          // boxShadow: isSelected ? '0 0 8px rgba(255, 77, 79, 0.6)' : 'none',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          setGrupaWykonan([]);
                          const isSame = selectedZamowienieId === stage.zamowienie_id;
                          setSelectedZamowienieId(isSame ? null : stage.zamowienie_id);
                          setSelectedShipmentDate(isSame ? null : stage.data_spedycji);
                          setSelectedGrup(stage);
                        }}
                        title={` ${stage.nr ||''} ${stage.rok||''} ${stage.firma_nazwa||''} ${stage.tytul||''} \n 
                        od: ${date_time(stage.start)}  do: ${date_time(stage.end)} 
                        Ilość narządów: ${stage.ilosc_narzadow || '--'}
                        Przeloty: ${stage.przeloty|| '--'} szt.
                        Spedycja: ${date_bez_time(stage.data_spedycji) || '--'}
                        Status: ${stage.status}
                        Element: ${getNameOfElementTyp(stage.typ_elementu, contextApp.typ_elementu) || '--'} 
                        Typ grupy: ${stage.typ_grupy}
                        Proces nazwa id: ${stage.proces_nazwa_id}

                        `}
                      >
                        <span className={styles.nameText}>
                          {` ${stage.firma_nazwa || `Przerwa`}`}
                        </span>

                        {/* Tooltip z podglądem nowej daty */}
                        {isCurrentlyResizing && resizingEndDate && (
                          <div className={styles.resizeTooltip}>
                            {resizingEndDate.toLocaleString('pl-PL', { 
                              month: '2-digit', 
                              day: '2-digit', 
                              hour: '2-digit', 
                              minute: '2-digit' 
                            })}
                          </div>
                        )}

                        {/* Uchwyt do zmiany rozmiaru (resize) */}
                        {resizable && (
                          <div
                            className={styles.resizeHandleRight}
                            onMouseDown={(e) => {
                              e.stopPropagation();
                              setIsResizing(true);
                              setResizingStage(stage);
                              setResizeStartX(e.clientX);
                              setCurrentWidthPx(baseWidthPx);
                              setResizingEndDate(new Date(stage.end));
                              const { leftPx } = calculateBarProperties(stage.start, stage.end);
                              setResizingLeftPx(leftPx + baseWidthPx);
                            }}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}

            <div className={styles.timeline}>
              <div className={styles.timelineMarkersContainer}>
                {renderTimelineMarkers('bottom')}
              </div>
              <div className={styles.timelineLine}></div>
            </div>
          </div>
        </div>
      </div>

      <GanttContextMenu
        setModalGrupyOpen={setModalGrupyOpen}
        contextMenu={contextMenu}
        onClose={() => setContextMenu(null)}
        onShowDetails={(stage) => {
          alert(`Szczegóły dla etapu: ${stage.name}`);
        }}
        onSelectOrder={(stage) => {
          setSelectedZamowienieId(stage.zamowienie_id);
          setSelectedShipmentDate(stage.data_spedycji);
        }}
        handleCenterOnStage={handleCenterOnStage}
      />
      <ModalGrupyTechnologii modalGrupyOpen={modalGrupyOpen} setModalGrupyOpen={setModalGrupyOpen} contextMenu={contextMenu} selectedGrup={selectedGrup} />
    </div>
  );
};

export default GanttChartAll;